import Button from '@/componentsDS/Button/Button';
import { ButtonType, ButtonVariant } from '@/componentsDS/Button/Button.type';
import { DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@dextech-ai/dex-design-system';
import Icon from '@/componentsDS/Icon/Icon';
import { IconSize, IconStyle } from '@/componentsDS/Icon/Icon.type';
import PropTypes from 'prop-types';

const PageSizeDropdownMenu = ({ options, selectedOption, onChange }) => {
	return (
		<DropdownMenu placement="bottomLeft">
			<DropdownMenuTrigger asChild>
				<div className="DS__dropdown-wrapper">
					<Button
						type={ButtonType.UTILITY}
						variant={ButtonVariant.UTILITY}
						text={
							<div className="ds-table__pagination-controls__left__dropdown__button">
								<Button type={ButtonType.UTILITY} variant={ButtonVariant.UTILITY} text={selectedOption[0].label} />
								<Icon name="chevron-down" size={IconSize.SMALL} style={IconStyle.SOLID} />
							</div>
						}
					/>
				</div>
			</DropdownMenuTrigger>
			<DropdownMenuContent>
				<DropdownMenuRadioGroup
					value={String(selectedOption[0]?.id)}
					onValueChange={(value) => onChange(options.filter((option) => String(option.id) === value))}
				>
					{options.map((option) => (
						<DropdownMenuRadioItem key={option.id} itemKey={String(option.id)} value={String(option.id)}>
							{option.label}
						</DropdownMenuRadioItem>
					))}
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default PageSizeDropdownMenu;

PageSizeDropdownMenu.propTypes = {
	options: PropTypes.array,
	selectedOption: PropTypes.array,
	onChange: PropTypes.func
}
